/* eslint-disable react/no-array-index-key */
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { BiLogOut } from 'react-icons/bi';

import { IMenuConf, adminMenu, juloaAdminMenu, proMenu, proMenuNoProfile } from 'conf/menu';

import useAuth from 'common/hooks/useAuth';
import useRouter from 'common/hooks/use-router';
import getWording from 'common/utils/wording';

interface IMenu {
  currentId: string;
  setSidebarOpen?: any;
}

const menuStyle = 'text-white hover:bg-slate-100 hover:bg-opacity-50';

function Menu({ currentId, setSidebarOpen }: IMenu) {
  const { t } = useTranslation();
  const { navigate } = useRouter();
  const { user: currentUser, signout } = useAuth();

  const renderMenu = (currentMenu: IMenuConf) => {
    return Object.keys(currentMenu).map((key: string, index: number) => {
      const { label, children } = currentMenu[key];

      const childrenList = children
        ?.filter((child) => !child.isReservedForJuloa || currentUser?.isJuloaAdmin)
        .map(({ id, Icon, label: childLabel, useWordingPlural }) => {
          const isCurrent = currentId?.includes(id);
          return (
            <Link
              key={id}
              to={`/${id}`}
              className={classNames(
                isCurrent ? 'bg-slate-100 bg-opacity-90 text-gray-900' : menuStyle,
                'relative group flex items-center px-2 py-2 text-sm font-medium rounded-2xl'
              )}
              onClick={setSidebarOpen ? () => setSidebarOpen(false) : () => {}}
            >
              <div
                className={`flex items-center justify-center ${
                  isCurrent ? 'bg-fourth' : 'bg-primary-300'
                } rounded-xl p-2 mr-3`}
              >
                <Icon
                  className={classNames(
                    isCurrent ? 'text-white font-bold' : 'text-white',
                    'flex-shrink-0 h-5 w-5'
                  )}
                  aria-hidden="true"
                />
              </div>
              {useWordingPlural
                ? t(`titlePages.${childLabel}`, {
                    wording: getWording(true, true),
                  })
                : t(`titlePages.${childLabel}`)}
            </Link>
          );
        });
      return (
        <div key={`menu-group${index}`}>
          <div className="mt-4 mb-2 text-sm text-white font-semibold" key={`menu-${index}`}>
            {t(`titleDividers.${label}`)}
          </div>
          {childrenList}
        </div>
      );
    });
  };

  const desktopScrollBar = `overflow-y-auto [&::-webkit-scrollbar]:w-1.5
  [&::-webkit-scrollbar-track]:rounded-full
  [&::-webkit-scrollbar-track]:bg-transparent
  [&::-webkit-scrollbar-thumb]:rounded-full
  [&::-webkit-scrollbar-thumb]:bg-secondary
  dark:[&::-webkit-scrollbar-track]:bg-transparent
  dark:[&::-webkit-scrollbar-thumb]:bg-neutral-500`;

  return (
    <div className="sidebar flex flex-col flex-1 h-full overflow-hidden ">
      <div className="flex flex-col px-2 pt-0  pb-0 md:pb-1 ">
        <img src="/images/main-logo.png" className="object-contain h-24" alt="Logo" />
      </div>

      <div className="rounded-3xl mr-4 bg-primary py-4 flex-1 h-full overflow-hidden">
        <div className={`h-full overflow-y-auto px-4 pb-6 ${desktopScrollBar}`}>
          {renderMenu(
            currentUser?.isJuloaAdmin
              ? juloaAdminMenu
              : currentUser?.isAdmin
              ? adminMenu
              : !currentUser?.operator
              ? proMenuNoProfile
              : proMenu
          )}

          <button
            type="button"
            className="group flex items-center px-2 py-2 text-sm font-medium rounded-lg mt-2  text-white bg-slate-100 hover:bg-opacity-50 bg-opacity-20
        w-full "
            onClick={() => {
              signout();
              navigate('/login');
            }}
          >
            <div className="flex items-center justify-center rounded-lg py-1 px-2 mr-3">
              <BiLogOut
                className={classNames('text-white', 'flex-shrink-0 h-5 w-5')}
                aria-hidden="true"
              />
            </div>
            {t('titlePages.logout')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Menu;
